// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"41254e1f","487":"c4b1664d","868":"304b375b","875":"f41178b7","947":"996be623"}[chunkId] + ".chunk.css";
};